import { createFileRoute } from '@tanstack/react-router';
import DripDashboardPage from '../../views/dashboard-drip/dashboard';

export const Route = createFileRoute('/dashboard/drip/dashboard')({
  component: DripDashboardPage,
});
